<section class="call-participants" [attr.id]="listId" role="region" aria-label="Participants">
    <header class="call-participants-header">
        <span class="call-participants-title">{{ title }}</span>
        <span class="call-participants-count">{{ inCallCount }} in the call</span>
        <!-- × puts the panel away (ITP-E-189-09), where the host listens for it. -->
        <button type="button" class="call-participants-close" *ngIf="closable" (click)="onClose()"
                aria-label="Close participants" title="Close">
            <i class="fa-solid fa-xmark" aria-hidden="true"></i>
        </button>
    </header>
    <ul class="call-participants-list">
        <li class="call-participants-row" *ngFor="let row of rows; trackBy: trackByEmail"
            [class.call-participants-row-out]="!row.inCall" [class.call-participants-row-speaking]="row.speaking">
            <span class="call-participants-avatar" aria-hidden="true">{{ row.initials }}</span>
            <span class="call-participants-name">
                <!-- A phone person (ITP-E-198-01): "📞 <name>", their number only ever masked. -->
                <span class="call-participants-phone-mark" *ngIf="row.phone" role="img" aria-label="Phone">📞 </span>{{ row.name }}<span
                    class="call-participants-host" *ngIf="row.isHost"> · Host</span>
                <span class="call-participants-number" *ngIf="row.phone"> {{ row.phone.masked }}</span>
            </span>
            <span class="call-participants-status">{{ row.label }}</span>
            <i class="fa-solid call-participants-voice" *ngIf="row.inCall" aria-hidden="true"
               [ngClass]="row.muted ? 'fa-microphone-slash' : row.speaking ? 'fa-waveform-lines' : 'fa-microphone'"></i>
            <!-- Cancel while it rings, Hang up once they answered: anyone in the call may (ITP-E-198-01). -->
            <button type="button" class="call-participants-hang-up" *ngIf="row.phone" (click)="onHangUpPhone(row)"
                    [attr.aria-label]="(row.phone.dialling ? 'Cancel the call to ' : 'Hang up ') + row.name"
                    [title]="row.phone.dialling ? 'Cancel the call' : 'Hang up the phone'">
                {{ row.phone.dialling ? 'Cancel' : 'Hang up' }}
            </button>
        </li>
    </ul>
</section>
